import createStaticResourceAPI from "@/helpers/rtk_static_resource_factory";
const type = 'THERAPEUTICAREAS';

export const therapeuticareasAPI = createStaticResourceAPI({
    baseURL: `${process.env.REACT_APP_GLOBO_API}/staticdata/therapeuticareas`,
    resource: "TherapeuticAreas",
    idKey: "therapeuticAreaId",
    tagTypes: ["GLOBO", "TherapeuticAreas"],
    lookupMap: ({ therapeuticAreaId, therapeuticAreaName }) => ({
        value: therapeuticAreaId,
        label: therapeuticAreaName,
    }),
    getInvalidationTags: ({ mode, patch }) => {
        const tags = [{ type: type, id: type }];
        if (mode === 'save' || mode === 'delete') {
            tags.push({ type: type, id: patch.therapeuticAreaId });
        }
        return tags; 
    },
});

export const {
    useGetTherapeuticAreasQuery,
    useFindTherapeuticAreasQuery,
    useLookUpTherapeuticAreasMutation,
    useDeleteTherapeuticAreasMutation,
    useSaveTherapeuticAreasMutation,
    useExportTherapeuticAreasMutation,
} = therapeuticareasAPI;
